import { v4 as uuidv4 } from "uuid";
import DocumentTemplateRepository from "../domain/data/DocumentTemplateRepository";
import DocumentTemplate from "../domain/entities/DocumentTemplate";
import Package from "../domain/entities/Package";
import User from "../domain/entities/User";
import { documentTemplates } from "./InitData";

export default class MockDocumentTemplateRepository
  implements DocumentTemplateRepository
{
  private static documentTemplates: DocumentTemplate[] = documentTemplates;

  async getDocumentTemplate(
    user: User,
    documentTemplateId: string
  ): Promise<DocumentTemplate | undefined> {
    return MockDocumentTemplateRepository.documentTemplates.find(
      (record) => record.id === documentTemplateId
    );
  }

  async loadDocTemplateByCampaign(
    userId: string,
    campaignid: string
  ): Promise<DocumentTemplate | undefined> {
    return MockDocumentTemplateRepository.documentTemplates[0];
  }

  async saveDocumentTemplate(
    user: User,
    documentTemplate: DocumentTemplate
  ): Promise<DocumentTemplate> {
    if (!documentTemplate.id) {
      documentTemplate.id = uuidv4();
      MockDocumentTemplateRepository.documentTemplates.push(documentTemplate);
      return documentTemplate;
    } else {
      const record = await this.getDocumentTemplate(user, documentTemplate.id);
      if (record) {
        record.description = documentTemplate.description;
        record.file = documentTemplate.file;
        record.name = documentTemplate.name;
        record.templateOwner = documentTemplate.templateOwner;
        record.shared = documentTemplate.shared;
      }
      return record as DocumentTemplate;
    }
  }
  async deleteDocumentTemplate(
    user: User,
    documentTemplate: DocumentTemplate
  ): Promise<boolean> {
    const record = MockDocumentTemplateRepository.documentTemplates.find(
      (record) => record.id === documentTemplate.id
    );
    if (record) {
      MockDocumentTemplateRepository.documentTemplates =
        MockDocumentTemplateRepository.documentTemplates.filter(
          (record) => record.id !== documentTemplate.id
        );
      return true;
    }
    return false;
  }
  async getDocumentTemplates(
    user: User,
    documentPackage?: Package,
    includeFiles?: boolean
  ): Promise<DocumentTemplate[]> {
    return MockDocumentTemplateRepository.documentTemplates;
  }
  async documentTemplateSignaturePosition(
    user: User,
    documentTemplate: DocumentTemplate,
    newFile: string
  ): Promise<DocumentTemplate> {
    documentTemplate.signaturePositionFile = newFile;
    return documentTemplate;
  }
  async translatePDF(
    documentTemplateId: string,
    language: string
  ): Promise<string> {
    throw new Error("Method not implemented.");
  }
}
